import { LoadingOverlay } from '@mantine/core';
import type { RefObject } from 'react';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { useSelectedMeasureOverTime } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { useTimeAllocationsData } from '../../hooks/measure-comparison';
import { useKeyMeasuresOverTimeData } from '../../hooks/key-measures-over-time';
import { KeyMeasuresOverTimeLineChart } from './line-chart/line-chart';

export const KeyMeasuresOverTime = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const selectedMeasureOverTime = useSelectedMeasureOverTime();

  const { data, isFetching, isLoading } = useKeyMeasuresOverTimeData();
  useTimeAllocationsData();

  if (!isFetching && (!data || Object.keys(data).length === 0)) {
    return <ContentPlaceholder />;
  }

  if (!selectedMeasureOverTime) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} style={{ zIndex: 200 }} />
      <KeyMeasuresOverTimeLineChart ref={chartRef} data={data} />
    </div>
  );
};
